// src/pages/Alarms.jsx

import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function Alarms() {
  return (
    <div className="min-h-screen bg-[#111111] text-white scroll-smooth">
      <Helmet>
        <title>Alarm Systems | SeguraTech</title>

        <meta
          name="description"
          content="Professional alarm systems, monitoring and maintenance for homes and businesses across Sussex. Installed and supported by SeguraTech."
        />

        {/* Open Graph */}
        <meta property="og:title" content="Alarm Systems | SeguraTech" />
        <meta
          property="og:description"
          content="Professional alarm installation, monitoring and maintenance services across Sussex."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.seguratech.co.uk/alarms"
        />
        <meta property="og:image" content="/ajax-ready.png" />
      </Helmet>

      {/* Hero */}
      <section className="max-w-4xl mx-auto px-4 py-24 text-center">
        <h1 className="text-4xl md:text-6xl font-extrabold leading-tight tracking-tight text-[#C6A564] mb-6">
          Alarm Systems
        </h1>

        <p className="text-lg text-white/80 mb-16">
          Professional security solutions for homes and businesses. From
          intelligent wireless alarm systems to professional monitoring and
          ongoing maintenance, SeguraTech delivers reliable protection tailored
          to your property.
        </p>
      </section>

      {/* Services */}
      <section className="max-w-6xl mx-auto px-4 pb-24">
        <div className="grid md:grid-cols-3 gap-8">

          {/* Ajax */}
          <Link
            to="/alarms/ajax"
            className="border border-[#C6A564] rounded-2xl p-10 bg-[#1a1a1a] hover:bg-[#222222] transition flex flex-col items-center text-center"
          >
            <img
              src={`${process.env.PUBLIC_URL}/ajax-ready.png`}
              alt="Ajax alarm systems installed by SeguraTech"
              className="h-16 w-auto object-contain mb-6"
            />

            <h2 className="text-2xl font-bold text-[#C6A564] mb-3">
              Ajax Security Systems
            </h2>

            <p className="text-white/70">
              Discover the award-winning Ajax ecosystem, including intrusion
              detection, fire protection and smart home automation.
            </p>
          </Link>

          {/* Monitoring */}
          <Link
            to="/alarms/monitoring"
            className="border border-[#C6A564] rounded-2xl p-10 bg-[#1a1a1a] hover:bg-[#222222] transition flex flex-col items-center text-center"
          >
            <img
              src={`${process.env.PUBLIC_URL}/Monitoring.png`}
              alt="Professional Alarm Monitoring"
              className="h-16 w-auto object-contain mb-6"
            />

            <h2 className="text-2xl font-bold text-[#C6A564] mb-3">
              Professional Monitoring
            </h2>

            <p className="text-white/70">
              Professional monitoring through trusted UK monitoring partners,
              providing additional peace of mind around the clock.
            </p>
          </Link>

          {/* Maintenance */}
          <Link
            to="/alarms/maintenance"
            className="border border-[#C6A564] rounded-2xl p-10 bg-[#1a1a1a] hover:bg-[#222222] transition flex flex-col items-center text-center"
          >
            <img
              src={`${process.env.PUBLIC_URL}/Maintenence.png`}
              alt="SeguraTech Maintenance and Support"
              className="h-16 w-auto object-contain mb-6"
            />

            <h2 className="text-2xl font-bold text-[#C6A564] mb-3">
              Maintenance & Support
            </h2>

            <p className="text-white/70">
              Keeping your alarm system performing at its best through servicing,
              updates and ongoing technical support.
            </p>
          </Link>

        </div>
      </section>
    </div>
  );
}
